import { date } from './date'
import { roundDownNumberOfCompanies } from './number'
import { percentage } from './percentage'

export const Formatting = { percentage, date, roundDownNumberOfCompanies }
export * from './number'
export * from './countryCode'
